module.exports = "<div class=\"arrow-box\" [ngClass]=\"arrowPosition\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"